import Stories from './stories'

export default Stories